import { styled } from '@mui/material'

export const TabContainer = styled('div')(({ theme }) => ({
    padding: theme.spacing(2, 0),
    width: '100%',
}))
